import { track } from 'helpers/tracking/tracking';
import { Product } from 'models/product';

export const trackPdpBlocker = async ({
  eventName,
  department,
  product: {
    brand,
    category,
    formattedSeason,
    isActive,
    isExcluded,
    model,
    modelNumber,
    productId,
    storeColor,
    store: { storeId },
  },
}: {
  department: string;
  eventName: string;
  product: Product;
}): Promise<void> => {
  return track(eventName, {
    categoryDepartment: {
      category: category.name,
      department: department.toLowerCase(),
    },
    product: {
      brand: brand.name,
      color: storeColor,
      isExcluded: isExcluded.toString(),
      model,
      modelNumber,
      productId,
      productIsActive: isActive.toString(),
      season: formattedSeason,
      store: storeId,
    },
  });
};
